import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Loader2, MapPin } from "lucide-react";
import { formatFicSedeDisplay } from "../utils/ficSedeInvio";

export default function ConfermaSedeFicDialog({
  open,
  onOpenChange,
  ficSede,
  numeroFattura,
  loading,
  onConfirm,
}) {
  const display = formatFicSedeDisplay(ficSede);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-left">
            <MapPin className="w-5 h-5 text-sky-600 shrink-0" />
            Importa indirizzo da FIC
          </DialogTitle>
          <DialogDescription className="text-left space-y-2">
            {numeroFattura && (
              <span className="block">
                Fattura <span className="font-mono text-slate-800">{numeroFattura}</span>
              </span>
            )}
            <span className="block">
              In Affidya manca un indirizzo di residenza valido per l&apos;invio SDI.
              Su Fatture in Cloud è presente:
            </span>
          </DialogDescription>
        </DialogHeader>
        {ficSede && (
          <div className="rounded-lg border border-sky-200 bg-sky-50/80 px-3 py-2.5 text-sm text-slate-800">
            <p className="font-medium">{display}</p>
            {ficSede.nome_fic && (
              <p className="text-xs text-slate-500 mt-1">Cliente FIC: {ficSede.nome_fic}</p>
            )}
          </div>
        )}
        <p className="text-xs text-slate-500">
          Confermando, l&apos;indirizzo verrà salvato in anagrafica ospite su Affidya e usato per l&apos;invio SDI.
        </p>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
            Annulla
          </Button>
          <Button type="button" onClick={onConfirm} disabled={loading} className="bg-sky-600 hover:bg-sky-700">
            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Salva e invia a SDI
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
